import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const telogisConfig: TSPConfig = {
  key: 'telogis',
  name: 'Telogis (Verizon Connect)',
  imageName: 'Telogis',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        To connect to Telogis (a Verizon Connect product), you’ll need to
        provide the credentials you use to log into the Telogis Web App.
      </p>
      <p>
        In addition, you must specify the <strong>Customer Name</strong> of your
        VZ Connect Fleet account. This name is used to identify your
        organization within the Telogis platform.
      </p>
      <p>You can locate your Customer Name by:</p>
      <ul>
        <li>
          Looking at the URL when logged into the platform — it appears just
          before <code>platform.telogis.com</code>.
        </li>
        <li>
          Checking the header area next to the “Support” menu while logged in.
        </li>
      </ul>
      <p>
        If you're unable to find your Customer Name, please contact Verizon
        Connect support for assistance.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Customer Name',
          name: 'database',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default telogisConfig;
